export const ACCEPTED_ATTACHMENTS = "application/pdf,.pdf,image/jpeg,image/png,image/webp,.jpg,.jpeg,.png,.webp";
const MAX_BYTES = 4 * 1024 * 1024;

const readDataUrl = (file) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(String(r.result));
  r.onerror = reject;
  r.readAsDataURL(file);
});

const compressImage = (dataUrl, maxSide = 1600) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * scale);
    c.height = Math.round(img.height * scale);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    resolve(c.toDataURL("image/jpeg", 0.85));
  };
  img.onerror = () => resolve(dataUrl);
  img.src = dataUrl;
});

// Ritorna {filename, base64, mime, previewUrl}
export async function readAttachment(file) {
  const name = file.name.toLowerCase();
  const isPdf = name.endsWith(".pdf");
  const isImage = /\.(jpe?g|png|webp)$/.test(name) || file.type.startsWith("image/");
  if (!isPdf && !isImage) throw new Error("Puoi allegare solo PDF o foto (JPG, PNG, WEBP).");
  let dataUrl = await readDataUrl(file);
  let filename = file.name;
  if (isImage) {
    dataUrl = await compressImage(dataUrl);
    filename = filename.replace(/\.[^.]+$/, "") + ".jpg";
  }
  const base64 = dataUrl.split(",")[1] || "";
  if (base64.length * 0.75 > MAX_BYTES) throw new Error("File troppo grande (max 4 MB).");
  return { filename, base64, mime: isImage ? "image/jpeg" : "application/pdf", previewUrl: isImage ? dataUrl : null };
}
